import { render } from "./AdminLayout.vue?vue&type=template&id=6f41ab15&scoped=true"
import script from "./AdminLayout.vue?vue&type=script&lang=js"
export * from "./AdminLayout.vue?vue&type=script&lang=js"

import "./AdminLayout.vue?vue&type=style&index=0&id=6f41ab15&lang=scss&scoped=true"

import exportComponent from "/var/www/moncasan_app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f41ab15"]])

export default __exports__